(function(){
  'use strict';
  // LINE友だち限定 先着10名 15%OFF — storefront display only. Shopify code MBLINE10
  // (usageLimit 10, once per customer, ends 9/30 24:00 JST) is the real gate; this file
  // only shows LINE visitors what that gate currently says.
  var offer=window.MonobloccGentei10;
  if(!offer)return;
  var STATUS_URL='https://monoblocc-preorder.vercel.app/api/offer-status';
  var KEY='mb_gentei10';
  var params=new URLSearchParams(location.search);
  function store(k,v){try{if(v===undefined)return localStorage.getItem(k);localStorage.setItem(k,v);}catch(e){return null;}}
  // Only people who came through the LINE link see any of this. General store visitors
  // are never shown a 15% they cannot get.
  if(params.get('offer')==='gentei10')store(KEY,String(Date.parse(offer.endsAt)));
  var until=Number(store(KEY));
  if(!until||Date.now()>until+24*3600*1000)return;

  var offset=0,status=null;
  var banner=document.getElementById('gentei10-banner');
  function now(){return Date.now()+offset;}
  function pad(n){return (n<10?'0':'')+n;}
  function remainingSeats(){return status&&typeof status.remaining==='number'?status.remaining:null;}
  function isOpen(){var r=remainingSeats();return offer.active(now())&&r!==0;}

  function paintBanner(){
    if(!banner)return;
    var r=remainingSeats(),active=offer.active(now());
    var q=function(s){return banner.querySelector(s);};
    if(now()<Date.parse(offer.startsAt)){banner.hidden=true;return;}
    banner.hidden=false;
    banner.classList.toggle('g10--closed',!isOpen());
    var seats=banner.querySelectorAll('[data-g10-seats] li');
    var used=r===null?0:offer.limit-r; // closed = sold or removed by the schedule
    for(var i=0;i<seats.length;i++)seats[i].classList.toggle('is-taken',i<used);
    q('[data-g10-seats]').hidden=r===null;
    q('[data-g10-deadline]').hidden=!isOpen();
    if(!active){
      q('[data-g10-title]').textContent='LINE友だち限定 15%OFFは終了しました';
      q('[data-g10-remaining]').textContent='';q('[data-g10-countdown]').textContent='';
      q('[data-g10-note]').textContent='ご予約は通常価格で引き続き承っています。';
      return;
    }
    if(r===0){
      q('[data-g10-title]').textContent='15%OFFの枠はなくなりました';
      q('[data-g10-remaining]').textContent='';q('[data-g10-countdown]').textContent='';
      q('[data-g10-note]').textContent='15%OFFの受付は終了しました。ご予約は通常価格で引き続き承っています。';
      return;
    }
    q('[data-g10-title]').textContent='LINE友だち限定 15%OFF 適用中';
    q('[data-g10-remaining]').textContent=r===null?'':'残り '+r+'名';
    var drop=status&&status.nextDropAt?Date.parse(status.nextDropAt):null;
    var target=drop&&drop>now()?drop:Date.parse(offer.endsAt);
    var ms=target-now(),h=Math.floor(ms/3600000),m=Math.floor(ms%3600000/60000),s=Math.floor(ms%60000/1000);
    q('[data-g10-countdown]').textContent=(target===drop?'次に枠が減るまで ':'終了まで ')+h+':'+pad(m)+':'+pad(s);
    q('[data-g10-note]').textContent='枠は時間とともに減ります。お会計時に自動で適用（コード入力不要・お一人さま1回）。';
  }

  function paintPrices(){
    var open=isOpen();
    document.querySelectorAll('[data-sw-price]').forEach(function(node){
      var label=node.querySelector('[data-g10-amount]');
      if(!label){label=document.createElement('div');label.setAttribute('data-g10-amount','');label.className='g10-price';node.appendChild(label);}
      var regular=Number(node.dataset.swPrice);
      var text='LINE限定15%OFF：¥'+Math.round(regular*(100-offer.percent)/100).toLocaleString('ja-JP')+(node.dataset.swVaries==='true'?'〜':'')+'（税込）';
      if(label.textContent!==text)label.textContent=text;
      label.hidden=!open;
    });
  }

  function paint(){paintBanner();paintPrices();}
  function refresh(){
    fetch(STATUS_URL,{cache:'no-store',mode:'cors'}).then(function(r){
      var server=Date.parse(r.headers.get('Date'));if(Number.isFinite(server))offset=server-Date.now();
      return r.json();
    }).then(function(j){if(j&&j.offer===offer.id)status=j;paint();}).catch(paint);
  }
  paint();refresh();
  setInterval(paint,1000);
  setInterval(refresh,60000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
})();
